// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__ieDpA","rotation":"Loader_rotation__3bFW-"};